import React from 'react'

const CoreComponent28 = ({DifferenceBox}) => {
  return (
    <div>
          <div className="bg-gray p-4 rounded-4 text-white">
            <h4 className="border-start ps-2 mb-4 border-warning border-5 text-white" >{DifferenceBox.title}</h4>
            <div>
              {DifferenceBox.child.map((val,i)=>(
                <div key={i} className="">
                  <div className="d-lg-flex " >
                    <strong className="fw-medium h3-heading diff-box border-warning position-relative element ps-3 ">{val.title}</strong>
                    <p className="ps-2 mb-2 h3-para">{val.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
    </div>
  )
}

export default CoreComponent28